import React from "react";
import {
  AdjustCartItemVariantSubscriptionInput,
  CartFragment,
  CreateCartFromOrderMutation,
} from "services/graphql/generated";

export interface CartContextInterface {
  cart: CartFragment | null;
  loading: boolean;
  refreshCart(): void;
  addCartItem(_input: AdjustCartItemVariantSubscriptionInput): Promise<void>;
  updateCartItem(_input: AdjustCartItemVariantSubscriptionInput): Promise<void>;
  getSize(): number | undefined;
  mergeCart(
    cartFromOrder: CreateCartFromOrderMutation["createTemporaryCartFromOrder"]
  ): Promise<CartFragment | void>;
  getCartId(): string | null;
}

export const CartContext = React.createContext<CartContextInterface>({
  cart: null,
  loading: true,
  refreshCart: () => {},
  addCartItem: async (_input: AdjustCartItemVariantSubscriptionInput) => {},
  updateCartItem: async (_input: AdjustCartItemVariantSubscriptionInput) => {},
  getSize: () => {
    return 0;
  },
  mergeCart: async () => {},
  getCartId: () => null,
});
